import styled from 'styled-components';

const SiteHeaderLeftWrapper = styled.div`
   flex-basis: 0;
`;

export { SiteHeaderLeftWrapper };
